export const getNullBelegState = (state) => state.nullBeleg;
export const getNullBelegStatus = (state) => state.nullBeleg.status;
